import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {Alert, Col, Input, Row, Tooltip} from "reactstrap";
import classnames from "classnames";

import {getCurrentMicroTime} from "../../../../../reducers/timeMeasuring/actions";
import {injectIntl} from "react-intl";

const KEY_1 = 'z';
const KEY_2 = 'm';
const KEY_NEXT = ' ';

class PresentationKeyboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false,
      keyDown: false,
      shouldRotatePhone: screen.height > screen.width,
    };

    this.keyUpCallback = this.keyUpCallback.bind(this);
    this.keyDownCallback = this.keyDownCallback.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.isTooltipOpen = this.isTooltipOpen.bind(this);
  }

  keyUpCallback(e) {
    if(['input', 'textarea'].includes(e.target.nodeName.toLowerCase())){
      return;
    }
    if(!this.state.keyDown){
      return;
    }

    if(this.state.shouldRotatePhone){
      return;
    }
    switch (e.key.toLowerCase()) {
      case KEY_1: {
        const answer = this.props.question.answers[0];
        this.selectItem(answer.id);
        break;
      }
      case KEY_2: {
        const answer = this.props.question.answers[1];
        this.selectItem(answer.id);
        break;
      }
      case KEY_NEXT: {
        this.props.changePage(1);
        break;
      }
    }

    this.setState({keyDown: false });
  }

  keyDownCallback(e){
    this.setState({
      keyDown: true,
    });
  }

  componentDidMount() {
    window.addEventListener('resize', () => {
      this.setState({
        shouldRotatePhone: screen.height > screen.width,
      })

    }, false);

    document.addEventListener("keydown", this.keyDownCallback);

    document.addEventListener("keyup", this.keyUpCallback, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyDownCallback);
    document.removeEventListener("keyup", this.keyUpCallback, false);
  }

  toggleTooltip(value) {
    if (this.state.tooltipOpen === value) {
      this.setState({tooltipOpen: false});
    }else{
      this.setState({tooltipOpen: value});
    }
  }

  isTooltipOpen(value) {
    return this.state.tooltipOpen === value;
  }

  selectItem(answer) {
    const detail = this.props.details.length > 0 ? this.props.details[0] : false;

    if((detail && detail.answer === answer)){
      return;
    }

    const microTime = getCurrentMicroTime(this.props.startTime);
    this.props.onDetailsUpdated([{
      answer,
      microTime
    }]);

    this.props.question.javascripts.map(javascript => {
      if(javascript.action === 'onAnswerSelected'){
        let func = new Function("return " + "function (answer) { " + javascript.code + " }")().bind(this);
        func(answer);
      }
    });
  }

  onOpenChange(e){
    const detail = this.props.details[0];

    this.props.onDetailsUpdated([{
      answer: detail.answer,
      content: e.target.value
    }]);
  }

  render() {
    const {shouldRotatePhone} = this.state;
    const {answers, details, answersImage} = this.props;
    const detail = details.length > 0 ? details[0] : false;

    if(shouldRotatePhone){
      return <div>
        <img src="/s/img/rotate.gif" className="d-block mx-auto" style={{background: '#ffd700', width: '50%' }} />
        <Alert color="warning" className="text-center mt-4">Obróć urządzenie poziomo</Alert>
      </div>
    }

    return (
        <React.Fragment>
          <div className="mx-0 d-flex justify-content-between" style={{fontSize: '2em'}}>
            {answers.map((answer) => {
              const checked = detail && parseInt(detail.answer) === answer.id;
              return <div
                key={answer.id}
                className={classnames({
                  'd-flex align-content-stretch': true,
                  'px-1': true,
                })}
              ><div
                className={classnames({
                  'cafetery-wrap d-flex flex-column w-100': true,
                  'justify-content-center flex-column': answersImage,
                  'active': checked,
                })}
                onClick={(e) => {
                  if(e.target.tagName != 'INPUT'){
                    this.selectItem(answer.id)
                  }
                }}
              >
                <div className="d-flex">
                  {answersImage ?
                    <div id={`tooltip-${answer.id}`} className="img-wrap align-self-center" key={answer.id} data-id={answer.id}>
                      <img src={answer.content} />
                      <Tooltip
                        delay={0}
                        placement="top"
                        isOpen={this.isTooltipOpen(answer.id)}
                        target={`tooltip-${answer.id}`}
                        toggle={() => this.toggleTooltip(answer.id)}
                      >
                        {answer.description}
                      </Tooltip>
                    </div> : <React.Fragment>
                      <span className="align-self-center w-100" dangerouslySetInnerHTML={{__html: answer.content}} />
                    </React.Fragment>}
                </div>

                {(answer.isOpen && checked) && <div className="d-flex"><Input className={classnames({
                  'mt-2': true,
                })} placeholder={this.props.intl.formatMessage({id: 'question.input.placeholder.typeYourAnswer'})} type="text" autoFocus={true} data-id={answer.id} bsSize="sm" onChange={this.onOpenChange} onBlur={this.onBlur} value={detail.content || ''}/></div>}
              </div></div>
            })}
          </div>
        </React.Fragment>
    );
  }
}

PresentationKeyboard.propTypes = {
  question: PropTypes.shape({
    javascripts: PropTypes.array.isRequired,
  }).isRequired,
  answers: PropTypes.array.isRequired,
  details: PropTypes.array.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
})(injectIntl(PresentationKeyboard));